import { jsx } from "react/jsx-runtime";
import { Box, Inline, Text, Link } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { root, link } from "./GlobalTabs.css.mjs";
const GlobalTab = ({
  href,
  text,
  linkContext,
  isActive = false
}) => {
  const { injectLinkContextToData } = useLink();
  return /* @__PURE__ */ jsx(
    Text,
    {
      align: "center",
      size: "xsmall",
      weight: isActive ? "strong" : void 0,
      tone: isActive ? "neutral" : "secondary",
      children: /* @__PURE__ */ jsx(
        Link,
        {
          className: [link],
          href,
          data: injectLinkContextToData(linkContext, {
            automation: linkContext.source
          }),
          children: text
        }
      )
    }
  );
};
const GlobalTabs = ({ tabList }) => /* @__PURE__ */ jsx(
  Box,
  {
    display: ["none", "flex"],
    justifyContent: "center",
    alignItems: "center",
    width: "full",
    background: "neutralLight",
    paddingY: "xsmall",
    className: root,
    children: /* @__PURE__ */ jsx(Inline, { space: "large", children: tabList.map(({ href, text, isActive, linkContext }, index) => /* @__PURE__ */ jsx(
      GlobalTab,
      {
        href,
        text,
        isActive,
        linkContext
      },
      `globalTab_${index}`
    )) })
  }
);
export {
  GlobalTabs
};
